import { registerTableEvent } from "../index";
import { toast } from "../../../toast";

registerTableEvent("peers.invitelink", "cell_click", (ctx) => {
  if (ctx.column?.id !== "device_status") return;

  const el = ctx.originalEvent.target as HTMLElement;
  const copyEl = el.closest("[data-copy-text]") as HTMLElement | null;
  if (!copyEl) return;

  const text = copyEl.dataset.copyText;
  if (text) {
    navigator.clipboard.writeText(text);
    toast.success("Ссылка скопирована");
  }
});
